module.exports = __webpack_public_path__ + "img/map-marker-distance.dc5328ff.svg";